var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"coupon-line"},[(_vm.text)?_c('div',{staticClass:"l-text"},[_vm._v(_vm._s(_vm.text))]):_c('div',{staticClass:"l-solid"})])}
var staticRenderFns = []

export { render, staticRenderFns }